module.exports = __webpack_public_path__ + "img/caret-down-square.8a2e81b2.svg";